import React from 'react';
import { TableRow, TableCell, Link } from '@mui/material';

const CarrierReportsTableRow = ({
  id,
  carrierName = '',
  country = '',
  standardSent = '',
  directSent = '',
  reminderSent = '',
  failedMessages = '',
  onClickCarrier = null,
  carrier = {},
}) => {
  return (
    <TableRow key={`list${id}`} id={id}>
      <TableCell name="date">
        <Link tabIndex={1} onClick={() => onClickCarrier(carrier)}>
          {carrierName}
        </Link>
      </TableCell>
      <TableCell name="country">{country}</TableCell>
      <TableCell align="right" name="standardSent">
        {standardSent}
      </TableCell>
      <TableCell align="right" name="directSent">
        {directSent}
      </TableCell>
      <TableCell align="right" name="reminderSent">
        {reminderSent}
      </TableCell>
      <TableCell align="right" name="failedMessages">
        {failedMessages}
      </TableCell>
    </TableRow>
  );
};

export default CarrierReportsTableRow;
